/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line


  let filter_bar = document.querySelector('.collection__nav--sort');
  let lastScrollY = window.scrollY;
  let ticking = false;

  function handleScroll() {
      const currentScrollY = window.scrollY;

      // Hide on scroll down
      if (currentScrollY > lastScrollY && currentScrollY > 50) {
          filter_bar.style.transform = 'translateY(-100%)';
      } 
      // Show on scroll up
      else {
          filter_bar.style.transform = 'translateY(0)';
      }

      lastScrollY = currentScrollY;
      ticking = false;
  }

  // Throttle scroll event to 50ms
  window.addEventListener('scroll', () => {
      if (!ticking) {
          ticking = true;

          setTimeout(() => {
              handleScroll();
          }, 50);
      }
  });

  // Optional smooth animation
  filter_bar.style.transition = 'transform 0.3s ease';


  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();
